import { inputPinPhases, PollView } from '../../playerStore.types';
import { PlayerPinReducer, PlayerPinReducerFactory } from '../reducers.types';
import { nextPhase } from '../reducers.utils';

export type PollReducer = PlayerPinReducer<PollView>;

export const createPollReducer: PlayerPinReducerFactory<PollView> = () => pollReducer;

export const pollReducer: PollReducer = {
  phases: inputPinPhases,
  initial: () => {
    return {
      type: 'POLL',
      phase: 'input',
    };
  },
  hasNextView: (_, currentView, direction) => {
    return nextPhase(currentView.phase, pollReducer.phases, direction) !== null;
  },
  handleNextView: (state, prev, direction) => {
    if (!state.currentView) {
      return false;
    }

    const next = nextPhase(prev.phase, pollReducer.phases, direction);
    if (next) {
      return {
        ...prev,
        type: 'POLL',
        phase: next,
      };
    }
    return false;
  },
  onEntriesUpdate: (_, currentView) => {
    return {
      ...currentView,
    };
  },
};
